import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
  AiFillSetting,
} from "react-icons/ai";

import { IoIosCall } from "react-icons/io";
import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <strong className="purple namelogo">🆅🅸🆂🅷🅰🅻</strong>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link
                href={"#home"}
                onClick={() => {
                  updateExpanded(false);
                  setActiveComponent("home");
                }}
                active={activeComponent === "home"}
                className={activeComponent === "home" ? "hoveractive" : ""}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                // as={Link}
                href={"#about"}
                // onClick={() => updateExpanded(false)}
                onClick={() => {
                  updateExpanded(false);
                  setActiveComponent("about");
                }}
                active={activeComponent === "about"}
                className={activeComponent === "about" ? "hoveractive" : ""}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                // as={Link}
                href={"#skills"}
                onClick={() => {
                  updateExpanded(false);
                  setActiveComponent("skills");
                }}
                active={activeComponent === "skills"}
                className={activeComponent === "skills" ? "hoveractive" : ""}
              >
                <AiFillSetting style={{ marginBottom: "2px" }} /> Skills
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                // as={Link}
                href={"#project"}
                onClick={() => {
                  updateExpanded(false);
                  setActiveComponent("project");
                }}
                active={activeComponent === "project"}
                className={activeComponent === "project" ? "hoveractive" : ""}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                // as={Link}
                href={"#contact"}
                onClick={() => {
                  updateExpanded(false);
                  setActiveComponent("contact");
                }}
                active={activeComponent === "contact"}
                className={activeComponent === "contact" ? "hoveractive" : ""}
              >
                <IoIosCall style={{ marginBottom: "2px" }} /> Contact
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://drive.google.com/file/d/1uWhyVgoG90Uw8EakVDIeIL1Y4N7M_cV3/view?usp=share_link"
                // href={
                //   "https://drive.google.com/file/d/16OX4u_WgtAiaXIky1zEYISl2y-lTjjR8/view?usp=sharing"
                // }
                target="_blank"
                onClick={() => updateExpanded(false)}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>

            {/* <Nav.Item className="fork-btn">
              <Button
                href="https://github.com/VishalBhuse"
                target="_blank"
                className="fork-btn-inner"
              >
                <CgGitFork style={{ fontSize: "1.2em" }} />
                <AiFillStar style={{ fontSize: "1.1em" }} />
              </Button>
            </Nav.Item> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
